import MOBILE from './mobile-svgrepo-com.svg';
import LAPTOP from './laptop-alt-2-svgrepo-com.svg';
import IPAD from './ipad-svgrepo-com.svg';

export default {
  MOBILE,
  LAPTOP,
  IPAD,
};
